import { Box, Typography, TextField, Divider } from '@mui/material'
import { useECGAnnotations } from '../context/ECGAnnotationsContext'

/**
 * Componente que exibe todas as anotações médicas feitas nas derivações
 * Mostra apenas as derivações que possuem anotações
 */
export const ECGAnnotationsSummary = () => {
  const { annotations } = useECGAnnotations()

  // Filtra apenas anotações não vazias
  const activeAnnotations = Object.entries(annotations).filter(
    ([_, annotation]) => annotation.trim() !== ''
  )

  if (activeAnnotations.length === 0) {
    return null
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant='h6'
        sx={{ mb: 2, color: 'var(--primarySoft-button-color)' }}
      >
        Anotações Médicas por Derivação
      </Typography>

      {activeAnnotations.map(([lead, annotation]) => (
        <Box key={lead} sx={{ mb: 2 }}>
          <Typography
            variant='subtitle2'
            sx={{ fontWeight: 'bold', mb: 1, color: 'primary.main' }}
          >
            Derivação {lead}:
          </Typography>
          <TextField
            fullWidth
            multiline
            value={annotation}
            disabled
            variant='outlined'
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(0, 0, 0, 0.02)'
              },
              '& .Mui-disabled': {
                color: 'rgba(0, 0, 0, 0.87)',
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)'
              }
            }}
          />
        </Box>
      ))}

      <Divider sx={{ mt: 3 }} />
    </Box>
  )
}
